/* Ability Warehouse — shared product index: loads the catalogue list once, matches search text, renders cards */
(function () {
  'use strict';
  if (window.CWIndex) return;
  var cfg = window.CW || {};
  var TTL = 20 * 60 * 1000;
  var mem = {};

  function money(c) {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((c || 0) / 100);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function cacheGet(k) {
    try { var raw = sessionStorage.getItem(k); if (!raw) return null; var o = JSON.parse(raw); if (Date.now() - o.t > TTL) return null; return o.d; } catch (e) { return null; }
  }
  function cacheSet(k, d) { try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }

  function prep(it) {
    // per = the price shown on cards (what the viewer pays); products are sold per unit
    it.per = it.p;
    it.ul = '';
    it.url = '/products/' + it.h;
    var tagText = (it.tg || []).join(' ').replace(/-/g, ' ');
    it.hay = [it.t, it.br, it.wr, it.wd, it.sh, it.mt, it.uf, it.nd, tagText].join(' ').toLowerCase().replace(/\s*x\s*/g, 'x');
    it.tl = it.t.toLowerCase().replace(/\s*x\s*/g, 'x');
    return it;
  }

  /* src: collection url, e.g. /collections/all */
  function load(src) {
    src = src || '/collections/all';
    if (mem[src]) return mem[src];
    var key = 'cwidx:' + (cfg.v || '') + (cfg.member ? 'm' : 'g') + src;
    var cached = cacheGet(key);
    if (cached) { mem[src] = Promise.resolve(cached.map(prep)); return mem[src]; }
    var sep = src.indexOf('?') > -1 ? '&' : '?';
    var get = function (n) {
      return fetch(src + sep + 'view=index&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    };
    mem[src] = get(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(get(n));
      return Promise.all(rest).then(function (pages) {
        var all = first.items;
        pages.forEach(function (p) { all = all.concat(p.items); });
        cacheSet(key, all);
        return all.map(prep);
      });
    }).catch(function (e) { delete mem[src]; throw e; });
    return mem[src];
  }

  var STOP = { the: 1, a: 1, an: 1, for: 1, and: 1, in: 1, with: 1, of: 1, to: 1, my: 1, i: 1, need: 1, product: 1, products: 1 };
  var SYN = {
    toilet: ['toilet', 'commode', 'toileting'], loo: ['toilet', 'commode'], commode: ['commode', 'toilet'],
    shower: ['shower', 'bath'], bath: ['bath', 'shower'], bathroom: ['bathroom', 'shower', 'bath'],
    walker: ['walker', 'rollator', 'walking frame'], rollator: ['rollator', 'walker'], frame: ['frame', 'walker'],
    stick: ['stick', 'cane'], cane: ['cane', 'stick'], wheelchair: ['wheelchair'], scooter: ['scooter'],
    rail: ['rail', 'grab bar', 'grab rail'], grab: ['grab', 'rail'], bar: ['bar', 'rail'],
    reacher: ['reacher', 'reaching', 'pick up'], grabber: ['reacher', 'grabber', 'pick up'],
    pads: ['pad', 'pads', 'incontinence'], nappies: ['nappies', 'nappy', 'briefs', 'incontinence'], nappy: ['nappies', 'nappy', 'briefs'],
    brace: ['brace', 'support', 'splint'], support: ['support', 'brace'], knee: ['knee'], back: ['back', 'lumbar'], wrist: ['wrist', 'hand'],
    bed: ['bed', 'overbed', 'mattress'], chair: ['chair', 'seat', 'seating'], seat: ['seat', 'chair'], cushion: ['cushion', 'pressure'],
    lift: ['lift', 'riser', 'recliner'], riser: ['riser', 'lift'], recliner: ['recliner', 'lift chair'],
    smart: ['smart', 'voice', 'sensor'], alarm: ['alarm', 'alert', 'sensor'], fall: ['fall', 'falls', 'alert'], falls: ['fall', 'falls'],
    grey: ['grey', 'gray'], gray: ['grey', 'gray'], bariatric: ['bariatric', 'heavy duty', 'wide'], wide: ['wide', 'bariatric'],
    kids: ['kids', 'children', 'child', 'youth'], ramp: ['ramp', 'threshold']
  };
  function tokens(q) {
    return String(q || '').toLowerCase().replace(/(\d)\s*(x|×|by)\s*(\d)/g, '$1x$3').replace(/[^\w\s.×-]/g, ' ').split(/\s+/)
      .filter(function (t) { return t && !STOP[t]; });
  }
  function score(it, toks) {
    var s = 0;
    for (var i = 0; i < toks.length; i++) {
      var opts = SYN[toks[i]] || [toks[i]], best = 0;
      for (var j = 0; j < opts.length; j++) {
        var o = opts[j];
        if (it.tl.indexOf(o) > -1) best = Math.max(best, (' ' + it.tl).indexOf(' ' + o) > -1 ? 4 : 3);
        else if (it.hay.indexOf(o) > -1) best = Math.max(best, 1);
      }
      if (!best) return 0;
      s += best;
    }
    return s + (it.a ? 0.5 : 0);
  }
  function search(items, q) {
    var toks = tokens(q);
    if (!toks.length) return items.slice();
    var out = [];
    items.forEach(function (it, i) { var s = score(it, toks); if (s) out.push({ it: it, s: s, i: i }); });
    out.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    return out.map(function (o) { return o.it; });
  }

  function priceHTML(it) {
    var onSale = it.r > it.p;
    var member = cfg.member ? '<span class="price__box price__member"><b>Member price</b></span>'
      : '<span class="price__box price__member">Members pay <b>' + money(it.m) + '</b>' + (cfg.joinUrl ? ' · <a href="' + cfg.joinUrl + '">join from $' + (cfg.monthly || 27) + '/mo</a>' : '') + '</span>';
    return '<div class="price"><div class="price__row"><span class="price__now">' + money(it.per) + '</span><span class="price__unit"></span>' +
      (onSale ? '<s class="price__was"><span class="price__rrp">RRP </span>' + money(it.r) + '</s>' : '') + '</div>' +
      (onSale ? '<span class="save-tag">Save ' + money(it.r - it.per) + '</span>' : '') + member + '</div>';
  }
  function img(src, w) { return src ? src.replace(/width=\d+/, 'width=' + w) : ''; }
  function card(it) {
    var pct = it.r > it.p ? Math.round((it.r - it.p) * 100 / it.r) : 0;
    var spec = [it.wr, it.wd, it.sh ? 'seat ' + it.sh : ''].filter(Boolean).join(' · ');
    var isNew = (it.tg || []).indexOf('new') > -1;
    return '<article class="card"><a class="card__media" href="' + it.url + '" aria-label="' + esc(it.t) + '">' +
      (it.im ? '<img class="card__img" loading="lazy" src="' + img(it.im, 400) + '" srcset="' + img(it.im, 240) + ' 240w, ' + img(it.im, 400) + ' 400w, ' + img(it.im, 600) + ' 600w" sizes="(min-width: 990px) 22vw, 50vw" alt="' + esc(it.t) + '" width="400" height="400">' : '<span class="card__img placeholder"></span>') +
      '<span class="card__badges">' + (it.br ? '<span class="badge">' + esc(it.br) + '</span>' : '') + (isNew ? '<span class="badge">New</span>' : '') + '</span>' +
      (pct > 0 ? '<span class="sticker">−' + pct + '%</span>' : '') + '</a>' +
      '<div class="card__body"><a class="card__title" href="' + it.url + '">' + esc(it.t) + '</a>' +
      (spec ? '<p class="card__spec">' + esc(spec) + '</p>' : '') +
      (it.a ? '<p class="stock stock--in"><span class="dot"></span>In stock</p>' : '<p class="stock stock--out"><span class="dot"></span>Sold out</p>') +
      priceHTML(it) + '</div><div class="card__actions"><a class="btn btn--red btn--sm" href="' + it.url + '">View &amp; buy</a></div></article>';
  }

  window.CWIndex = { load: load, search: search, tokens: tokens, card: card, priceHTML: priceHTML, money: money, esc: esc, img: img };
})();
